import { render, staticRenderFns } from "./ProfileDataForm.vue?vue&type=template&id=6964a620&scoped=true&lang=pug&"
import script from "./ProfileDataForm.vue?vue&type=script&lang=js&"
export * from "./ProfileDataForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDataForm.vue?vue&type=style&index=0&id=6964a620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964a620",
  null
  
)

export default component.exports